import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Tooltip,
  Avatar,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  Person as PersonIcon,
  Logout as LogoutIcon,
  Height,
  SpaceBarRounded,
} from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearUserData } from "../redux/actions/userActions";

const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated, userData } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleLogoClick = () => {
    navigate("/");
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(clearUserData());
    handleMenuClose();
    navigate("/");
  };

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        bgcolor: "#F7F3F2",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          px: { xs: 1, sm: 2 },
          minHeight: { xs: 48, sm: 64 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            gap: 2,
            cursor: "pointer",
            justifyContent: "space-between",
          }}
          onClick={handleLogoClick}
        >
          <img
            src="/akash/images/lakshya.png"
            alt="Lakshya Logo"
            style={{
              height: "40px",
              width: "auto",
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!isAuthenticated ? (
            // <Button
            //   component={Link}
            //   to="/login"
            //   variant="outlined"
            //   color="primary"
            //   size={isMobile ? "small" : "medium"}
            //   sx={{
            //     textTransform: 'none',
            //     px: { xs: 1, sm: 2 },
            //     py: { xs: 0.5, sm: 1 },
            //     fontSize: { xs: '0.75rem', sm: '0.875rem' },
            //     borderRadius: 2,
            //     borderWidth: 2,
            //     '&:hover': {
            //       borderWidth: 2,
            //       backgroundColor: 'transparent',
            //     }
            //   }}
            // >
            //   Login
            // </Button>
            // <p className="text-dark">943898493</p> 
            <p
            className="text-dark d-flex align-items-center"
            style={{ marginTop: '20px' }}     // ← here
          >
            <img
              src="/akash/images/call-ibt.png"
              alt="Call"
              style={{
                width: '20px',
                height: '20px',
                marginRight: '8px',
                // remove its marginTop
              }}
            />
            91-8503887038
          </p>
          
          ) : (
            <>
              <Button
                component={Link}
                to="/dashboard"
                variant="outlined"
                color="primary"
                size={isMobile ? "small" : "medium"}
                sx={{
                  textTransform: "none",
                  px: { xs: 1, sm: 2 },
                  py: { xs: 0.5, sm: 1 },
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  borderRadius: 2,
                  borderWidth: 2,
                  "&:hover": {
                    borderWidth: 2,
                    backgroundColor: "transparent",
                  },
                }}
              >
                Dashboard
              </Button>
              <Tooltip title="Profile">
                <Avatar
                  onClick={handleProfileClick}
                  sx={{
                    bgcolor: "primary.main",
                    cursor: "pointer",
                    width: { xs: 32, sm: 40 },
                    height: { xs: 32, sm: 40 },
                  }}
                >
                  <PersonIcon />
                </Avatar>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
